import { Button } from 'antd';
import { MailOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { SEO } from '../../components/common/SEO';
import { MarketingLayout } from './MarketingLayout';

/**
 * /contact - how schools and parents reach Rongeka. Only published contact details.
 */
export const ContactPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MarketingLayout current="/contact">
      <SEO
        title="Contact Rongeka Africa | School Management System Support"
        description="Contact Rongeka Africa by email at support@rongeka.africa or on WhatsApp at +263 78 944 2202 for questions about the school management system, a free term, or support."
        url="https://rongeka.africa/contact"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          url: 'https://rongeka.africa/contact',
          name: 'Contact Rongeka Africa',
          about: { '@id': 'https://rongeka.africa/#organization' },
        }}
      />

      <header className="mkt-hero">
        <div className="landing-section-label">CONTACT</div>
        <h1 className="mkt-hero-title">Contact Rongeka Africa</h1>
        <p className="mkt-hero-lead">
          Questions about the system, pricing, or getting your school set up? Email or
          WhatsApp the Rongeka team.
        </p>
        <div className="mkt-hero-actions">
          <Button
            type="primary"
            size="large"
            icon={<WhatsAppOutlined />}
            href="https://wa.me/263789442202"
            target="_blank"
            rel="noopener noreferrer"
          >
            WhatsApp +263 78 944 2202
          </Button>
          <Button size="large" icon={<MailOutlined />} href="mailto:support@rongeka.africa">
            support@rongeka.africa
          </Button>
        </div>
      </header>

      <section className="mkt-section">
        <div className="mkt-content">
          <h2 className="mkt-section-heading">Schools</h2>
          <p className="mkt-section-body">
            You do not need to book a demo to try Rongeka. Register your school and use the
            full core platform free for one term. If you would rather talk first, tell us
            your school's name, roughly how many students you have, and what you want to
            replace - paper registers, spreadsheets, or another system - and we will take
            it from there.
          </p>
          <div className="mkt-hero-actions">
            <Button type="primary" size="large" onClick={() => navigate('/get-started')}>
              Start Your Free Term
            </Button>
            <Button size="large" onClick={() => navigate('/pricing')}>
              See Pricing
            </Button>
          </div>
        </div>
      </section>

      <section className="mkt-section mkt-section-alt">
        <div className="mkt-content">
          <h2 className="mkt-section-heading">Parents and guardians</h2>
          <p className="mkt-section-body">
            Your child's school manages their records, fees and results in Rongeka, so
            questions about a balance, a payment or a report card are best sent to the
            school. If your school uses Rongeka, you can message it from the WhatsApp
            menu. Read more about{' '}
            <RouterLink to="/features/whatsapp">Rongeka on WhatsApp</RouterLink>.
          </p>
        </div>
      </section>
    </MarketingLayout>
  );
};
